import React from 'react'

import { Button, Icon } from '@clientbase/clientbase-library'
import mixpanel from 'mixpanel-browser'
import { useRouter } from 'next/router'

import { theme } from 'styles/theme'

import * as S from './styles'
interface ActivateButtonProps {
  isAppBarButton?: boolean
}
const ActivateButton = ({ isAppBarButton = false }: ActivateButtonProps) => {
  const { push } = useRouter()
  const appBarStyled = {
    bgColor: '#294266',
    color: 'white'
  }
  const mixpanelTyped = mixpanel as unknown as { __loaded: string }
  return (
    // O clique fica no botão inteiro: só no texto/ícone de dentro, o toque no
    // padding do botão (comum no celular) não abria o cadastro.
    <Button
      variantButton="neutral"
      onClick={() => {
        push('/ativar-conta')
        mixpanelTyped.__loaded &&
          mixpanel.track('Concluir cadastro topbar banner')
      }}
      sx={{
        ...(isAppBarButton && {
          bgcolor: appBarStyled.bgColor,
          padding: '20px 14px',
          minWidth: '190px',
          [theme.breakpoints.down(800)]: {
            minWidth: 'auto',
            marginRight: '10px'
          },
          ':hover': {
            bgcolor: appBarStyled.bgColor,
            padding: '20px 14px'
          }
        }),
        ...(!isAppBarButton && {
          [theme.breakpoints.down(800)]: {
            width: '100%'
          }
        }),
        border: 'none',
        '&:hover': {
          border: 'none'
        }
      }}
    >
      <S.Link
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '5px',
          fontWeight: '600',
          ...(isAppBarButton && {
            color: appBarStyled.color
          })
        }}
      >
        Concluir cadastro
        <Icon
          icon="open"
          width="21px"
          height="21px"
          ml="6px"
          sx={{
            cursor: 'pointer',
            color: '#393939',
            ...(isAppBarButton && {
              color: appBarStyled.color
            })
          }}
        />
      </S.Link>
    </Button>
  )
}

export default ActivateButton
